import { styled } from '../../../Utilities';
import { getStyles } from './ShimmerCircle.styles';
import { ShimmerCircleBase } from './ShimmerCircle.base';
export var ShimmerCircle = styled(ShimmerCircleBase, getStyles, undefined, {
  scope: 'ShimmerCircle'
});